export default "__VITE_ASSET__DBS3$7nl__"